<!-- [3]「イベントID(1)にて、設定した支払方法利用可否判定マップを基に、以下の通りに設定する。 支払方法利用可否判定マップ.<key>.value = trueの要素 > 1件の場合に表示する。 
※支払方法利用可否判定マップ.<key>.value = trueの要素 = 1件の場合、その支払方法が選択されている扱いとする。-->
<ng-container *ngIf="getVisiblePaymentMethods().length > 1">
  <!-- [見出し領域] -->
  <div class="p-heading-area01">
    <h2 class="p-heading-area01__title c-heading-2" [innerHTML]="'heading.price1' | staticMsg"></h2>
  </div>
  <ul class="l-tab-menu01__list" [formGroup]="paymentInputFG">
    <!-- (4.1) 画面.支払方法選択を表示し、画面.選択済支払方法グループを非表示とする。 -->
    <li
      class="l-tab-menu01__list-item l-tab-menu01__list-item--change"
      [ngClass]="{ 'is-open': isSp && isDisplayPaymentMethodSelectionSP }"
    >
      <div class="l-tab-menu01__change">
        <div class="l-tab-menu01__change-title">
          <ng-container *ngFor="let paymentItem of listPaymentMethod">
            <ng-container *ngIf="isCurrentMethod(paymentItem.paymentMethod)">
              <span class="l-tab-menu01__change-title-icon">
                <img
                  src="{{ paymentItem.icon }}"
                  height="{{ paymentItem.size.height }}"
                  width="{{ paymentItem.size.width }}"
                  alt="{{ paymentItem.alt | staticMsg }}"
                />
              </span>
              <span
                class="l-tab-menu01__change-title-label"
                [innerHTML]="cardCreditLabel | staticMsg"
                *ngIf="isCreditCard(paymentItem.paymentMethod)"
              >
              </span>
              <span class="u-visually-hidden" [innerHTML]="'選択中'"></span>
            </ng-container>
          </ng-container>
        </div>
        <div class="l-tab-menu01__change-btn">
          <asw-button
            type="tertiary"
            size="xs"
            [label]="'label.cardChange' | staticMsg"
            (click$)="onPaymentMethodChangeSP()"
          ></asw-button>
        </div>
      </div>
    </li>
    <!-- (4.1) 画面.支払方法選択を表示し、画面.選択済支払方法グループを非表示とする。 -->
    <li
      class="l-tab-menu01__list-item l-tab-menu01__list-item--menu"
      [ngClass]="{ 'is-hide': isSp && isDisplayPaymentMethodSelectionSP }"
    >
      <div class="l-tab-menu01__menu l-tab-menu01__menu--tb-pc-2col" role="tablist">
        <ng-container *ngFor="let paymentItem of listPaymentMethod">
          <button
            *ngIf="paymentItem.isDisplay && getPaymentMethod(paymentItem.paymentMethod); let method"
            (click)="onChangePaymentMethod(paymentItem.paymentMethod)"
            [ngClass]="{ 'is-current': isCurrentMethod(paymentItem.paymentMethod) }"
            class="l-tab-menu01__menu-item"
            type="button"
            id="tab-{{ method }}"
            role="tab"
            [attr.aria-controls]="'panel-' + method"
            [attr.aria-selected]="isCurrentMethod(paymentItem.paymentMethod) ? 'true' : 'false'"
            [attr.tabindex]="isCurrentMethod(paymentItem.paymentMethod) ? '-1' : '0'"
          >
            <span class="l-tab-menu01__menu-title">
              <span class="l-tab-menu01__menu-title-icon">
                <img
                  src="{{ paymentItem.icon }}"
                  height="{{ paymentItem.size.height }}"
                  width="{{ paymentItem.size.width }}"
                  alt="{{ paymentItem.alt | staticMsg }}"
                />
              </span>
              <span
                class="l-tab-menu01__menu-title-label l-tab-menu01__menu-title-label--em"
                [innerHTML]="cardCreditLabel | staticMsg"
                *ngIf="isCreditCard(paymentItem.paymentMethod)"
              >
              </span>
            </span>
            <span class="l-tab-menu01__menu-mark"></span>
          </button>
        </ng-container>
        <button
          *ngIf="isPaddingItem"
          style="visibility: hidden"
          class="l-tab-menu01__menu-item"
          type="button"
          id="padding-item"
          role="tab"
          aria-selected="false"
          tabindex="-1"
        ></button>
      </div>
    </li>

    <li
      *ngIf="isDisplayCreditCardSelected"
      class="l-tab-menu01__list-item l-tab-menu01__list-item--mt16 l-tab-menu01__list-item--check"
    >
      <asw-checkbox formControlName="saveAsUsualCheckboxControl" [label]="'label.saveAsUsualPaymentMthod' | staticMsg">
      </asw-checkbox>
    </li>
  </ul>
</ng-container>
